module.exports = __webpack_public_path__ + "img/passenger.bbeb42cd.svg";